export const FOOD_ORDER_WEBSITE   = 'https://www.ezcater.com/?utm_source=openbooksmd';



// WEBPACK FOOTER //
// ./app/constants/foodOrder.js